import { useEffect, useState } from "react";

import { useCachedAdminApi } from "../../../../../../../common/api/admin-api/useCachedAdminApi";
import { formOptionsLoader } from "../../../../../../../common/components/form/FormOptionsLoader";
import { Language } from "../../../../../../../common/types/Language";

export const useCloudFileAssociationLanguageOptions = () => {
    const { getDubbings, getDynamicSubtitles, getEmbeddedSubtitles } = useCachedAdminApi();

    /* audios */
    const [dubbings, setDubbings] = useState<Language[]>([]);
    const [areDubbingsLoading, setAreDubbingsLoading] = useState(true);
    const loadDubbingOpts = (): void => formOptionsLoader(getDubbings, setAreDubbingsLoading, setDubbings);

    /* dynamic subs */
    const [dynamicSubtitles, setDynamicSubtitles] = useState<Language[]>([]);
    const [areDynamicSubtitlesLoading, setAreDynamicSubtitlesLoading] = useState(true);
    const loadDynamicSubtitleOpts = (): void =>
        formOptionsLoader(getDynamicSubtitles, setAreDynamicSubtitlesLoading, setDynamicSubtitles);

    /* embedded subs */
    const [embeddedSubtitles, setEmbeddedSubtitles] = useState<Language[]>([]);
    const [areEmbeddedSubtitlesLoading, setAreEmbeddedSubtitlesLoading] = useState(true);
    const loadEmbeddedSubtitleOpts = (): void =>
        formOptionsLoader(getEmbeddedSubtitles, setAreEmbeddedSubtitlesLoading, setEmbeddedSubtitles);

    useEffect(() => {
        loadDubbingOpts();
        loadDynamicSubtitleOpts();
        loadEmbeddedSubtitleOpts();
    }, []);

    return {
        dubbings,
        areDubbingsLoading,

        dynamicSubtitles,
        areDynamicSubtitlesLoading,

        embeddedSubtitles,
        areEmbeddedSubtitlesLoading
    };
};
